import { Component, Vue } from 'vue-property-decorator';
import AppFooterContactVue from './contact/AppFooterContact.vue';
import AppFooterDisclaimerVue from './disclaimer/AppFooterDisclaimer.vue';

@Component({
  components: {
    'app-footer-contact': AppFooterContactVue,
    'app-footer-disclaimer': AppFooterDisclaimerVue
  }
})
export default class AppFooter extends Vue {
  public get hasContact(): boolean {
    return this.$route.meta.contact !== false;
  }
}
